// WooCommerce Header Cart Update and Sidebar Cart
jQuery(document).ready(function ($) {
  // =========================================================================
  // CART SIDEBAR FUNCTIONALITY
  // =========================================================================
  function openCartSidebar() {
    $('#cart-sidebar').addClass('open');
    $('body').addClass('cart-sidebar-open');
  }

  function closeCartSidebar() {
    $('#cart-sidebar').removeClass('open');
    $('body').removeClass('cart-sidebar-open');
  }

  // =========================================================================
  // SHOP FILTERS - Mobile Drawer with Accessibility
  // =========================================================================
  function openShopFilters() {
    const $overlay = $('#shop-filters-overlay');
    const $toggle = $('#shop-filters-toggle');

    $overlay.addClass('active');
    $toggle.addClass('active').attr('aria-expanded', 'true');
    $('body').addClass('shop-filters-open');

    // Focus trap - focus on first focusable element
    setTimeout(() => {
      $overlay.find('input, button, select, textarea, a[href]').first().focus();
    }, 300);
  }

  function closeShopFilters() {
    const $overlay = $('#shop-filters-overlay');
    const $toggle = $('#shop-filters-toggle');

    $overlay.removeClass('active');
    $toggle.removeClass('active').attr('aria-expanded', 'false');
    $('body').removeClass('shop-filters-open');

    // Return focus to toggle button
    $toggle.focus();
  }

  // Shop filters toggle event
  $(document).on('click', '#shop-filters-toggle', function (e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      closeShopFilters();
    } else {
      openShopFilters();
    }
  });

  // Close shop filters when close button or overlay is clicked
  $(document).on('click', '.shop-filters-close', function (e) {
    e.preventDefault();
    closeShopFilters();
  });

  $(document).on('click', '.shop-filters-overlay', function (e) {
    if (e.target === this) {
      closeShopFilters();
    }
  });

  // Close shop filters with Escape key
  $(document).on('keydown', function (e) {
    if (e.keyCode === 27 && $('#shop-filters-overlay').hasClass('active')) {
      closeShopFilters();
    }
  });

  // =========================================================================
  // ACTIVE FILTERS - Display & Clear Functionality
  // =========================================================================
  function populateActiveFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const $container = $('.active-filters-pills');

    if (!$container.length) return;

    $container.empty();
    let hasFilters = false;

    // Price filters
    const minPrice = urlParams.get('min_price');
    const maxPrice = urlParams.get('max_price');
    if (minPrice || maxPrice) {
      hasFilters = true;
      const priceText =
        minPrice && maxPrice
          ? `$${minPrice} - $${maxPrice}`
          : minPrice
            ? `Over $${minPrice}`
            : `Under $${maxPrice}`;

      $container.append(`
        <div class="filter-pill" data-filter="price">
          <span class="filter-pill-label">Price:</span>
          <span>${priceText}</span>
          <button class="filter-pill-remove" aria-label="Remove price filter">&times;</button>
        </div>
      `);
    }

    // Category filters
    const category = urlParams.get('product_cat');
    if (category) {
      hasFilters = true;
      $container.append(`
        <div class="filter-pill" data-filter="product_cat" data-value="${category}">
          <span class="filter-pill-label">Category:</span>
          <span>${category.replace('-', ' ')}</span>
          <button class="filter-pill-remove" aria-label="Remove category filter">&times;</button>
        </div>
      `);
    }

    // Color filters (if using WooCommerce Product Filter plugin)
    urlParams.forEach((value, key) => {
      if (key.startsWith('filter_')) {
        hasFilters = true;
        const filterName = key.replace('filter_', '').replace('_', ' ');
        $container.append(`
          <div class="filter-pill" data-filter="${key}" data-value="${value}">
            <span class="filter-pill-label">${filterName}:</span>
            <span>${value}</span>
            <button class="filter-pill-remove" aria-label="Remove ${filterName} filter">&times;</button>
          </div>
        `);
      }
    });

    // Show/hide active filters container
    if (hasFilters) {
      $('.active-filters-container').show();
    } else {
      $('.active-filters-container').hide();
    }
  }

  // Remove individual filter
  $(document).on('click', '.filter-pill-remove', function (e) {
    e.preventDefault();
    const $pill = $(this).closest('.filter-pill');
    const filterType = $pill.data('filter');

    const url = new URL(window.location);

    if (filterType === 'price') {
      url.searchParams.delete('min_price');
      url.searchParams.delete('max_price');
    } else {
      url.searchParams.delete(filterType);
    }

    window.location.href = url.toString();
  });

  // Clear all filters
  $(document).on('click', '.clear-all-filters', function (e) {
    e.preventDefault();

    // Get base URL without query parameters
    const baseUrl = window.location.origin + window.location.pathname;
    window.location.href = baseUrl;
  });

  // Initialize active filters on page load
  populateActiveFilters();

  // =========================================================================
  // COLLAPSIBLE FILTER WIDGETS
  // =========================================================================
  $(document).on('click', '.shop-sidebar .widget-title', function () {
    const $widget = $(this).parent();
    const $content = $widget.find('ul, form, .price_slider_wrapper');

    $(this).toggleClass('collapsed');
    $content.slideToggle(300);
  });

  // =========================================================================
  // STICKY CONTROLS BAR ON SCROLL (Mobile)
  // =========================================================================
  let lastScrollTop = 0;
  const $controlsBar = $('.shop-controls-bar');

  if ($controlsBar.length && $(window).width() < 768) {
    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();

      if (scrollTop > 200) {
        $controlsBar.addClass('is-sticky');
      } else {
        $controlsBar.removeClass('is-sticky');
      }

      lastScrollTop = scrollTop;
    });
  }

  // =========================================================================
  // PRODUCT CARD QUICK ACTIONS (Wishlist, Quick View)
  // =========================================================================
  // Wishlist toggle
  $(document).on('click', '.quick-action-wishlist', function (e) {
    e.preventDefault();
    const $button = $(this);
    const productId = $button.data('product-id');

    $button.toggleClass('active');

    // Add your AJAX call to wishlist plugin here
    // Example: YITH WooCommerce Wishlist integration

    // Visual feedback
    const icon = $button.find('svg path');
    if ($button.hasClass('active')) {
      icon.attr('fill', 'currentColor');
    } else {
      icon.attr('fill', 'none');
    }
  });

  // Quick View (if you have a quick view plugin)
  $(document).on('click', '.quick-action-view', function (e) {
    e.preventDefault();
    const productId = $(this).data('product-id');

    // Trigger your quick view plugin
    // Example: WooCommerce Quick View integration
    $(document.body).trigger('woo_quick_view', [productId]);
  });

  // =========================================================================
  // LAZY LOADING IMAGES - Performance Optimization
  // =========================================================================
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');

          if (src) {
            img.setAttribute('src', src);
            img.removeAttribute('data-src');
            img.classList.add('loaded');
          }

          observer.unobserve(img);
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }

  // =========================================================================
  // LOAD MORE BUTTON (Alternative to Pagination)
  // =========================================================================
  let loadMorePage = 2;

  $(document).on('click', '.load-more-button', function (e) {
    e.preventDefault();
    const $button = $(this);
    const $productsContainer = $('ul.products');

    $button.addClass('loading').prop('disabled', true);

    $.ajax({
      url: ajax_variable.ajax_url,
      type: 'POST',
      data: {
        action: 'load_more_products',
        page: loadMorePage,
        query: ajax_variable.query_vars,
      },
      success: function (response) {
        if (response.success && response.data.products) {
          $productsContainer.append(response.data.products);
          loadMorePage++;

          if (!response.data.has_more) {
            $button.parent().hide();
          }
        }
      },
      complete: function () {
        $button.removeClass('loading').prop('disabled', false);
      },
    });
  });

  // =========================================================================
  // CART FUNCTIONALITY (Original)
  // =========================================================================
  // =========================================================================
  // CART FUNCTIONALITY (Original)
  // =========================================================================

  // Open cart sidebar when cart icon is clicked
  $(document).on('click', '.woo-cart-icon, .mobile-woo-cart-icon', function (e) {
    e.preventDefault();
    openCartSidebar();
  });

  // Close cart sidebar when close button or overlay is clicked
  $(document).on('click', '.cart-sidebar-close, .cart-sidebar-overlay', function () {
    closeCartSidebar();
  });

  // Close cart sidebar with Escape key
  $(document).on('keydown', function (e) {
    if (e.keyCode === 27 && $('#cart-sidebar').hasClass('open')) {
      closeCartSidebar();
    }
  });

  // Handle remove from cart in sidebar
  $(document).on('click', '.cart-sidebar .remove_from_cart_button', function (e) {
    e.preventDefault();
    var $removeButton = $(this);
    var cart_item_key = $removeButton.data('cart_item_key');

    $.ajax({
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      type: 'POST',
      data: {
        cart_item_key: cart_item_key,
      },
      success: function (response) {
        if (response && response.fragments) {
          updateCartSidebar();
          updateHeaderCartCount();
        }
      },
    });
  });

  // Update cart sidebar content
  function updateCartSidebar() {
    var ajaxUrl =
      ajax_variable.ajax_url ||
      (typeof wc_add_to_cart_params !== 'undefined'
        ? wc_add_to_cart_params.ajax_url
        : '/wp-admin/admin-ajax.php');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      data: {
        action: 'get_sidebar_cart_content',
      },
      success: function (response) {
        if (response.success) {
          $('#cart-sidebar .cart-sidebar-body').html(response.data.content);
          if (response.data.footer) {
            $('#cart-sidebar .cart-sidebar-footer').html(response.data.footer).show();
          } else {
            $('#cart-sidebar .cart-sidebar-footer').hide();
          }
        }
      },
    });
  }

  // Update cart count in header
  function updateHeaderCartCount() {
    var ajaxUrl =
      ajax_variable.ajax_url ||
      (typeof wc_add_to_cart_params !== 'undefined'
        ? wc_add_to_cart_params.ajax_url
        : '/wp-admin/admin-ajax.php');

    $.ajax({
      url: ajaxUrl,
      type: 'POST',
      data: {
        action: 'get_cart_count',
      },
      success: function (response) {
        if (response.success) {
          var cartCount = response.data.count;
          var $cartCountElement = $('.cart-count');
          var $mobileCartElement = $('.mobile-woo-cart-icon span');

          // Always show cart count, even if 0
          if ($cartCountElement.length) {
            $cartCountElement.text(cartCount);
          } else {
            $('.woo-cart-icon').append('<span class="cart-count">' + cartCount + '</span>');
          }

          // Update mobile cart text - always show count
          if ($mobileCartElement.length) {
            $mobileCartElement.text('Shopping Cart (' + cartCount + ')');
          }
        }
      },
    });
  }

  // Update cart on add to cart button click (WooCommerce event)
  $(document.body).on('added_to_cart', function () {
    updateHeaderCartCount();
    updateCartSidebar();
    // Auto-open sidebar when item is added
    openCartSidebar();
  });

  // Update cart when cart is updated
  $(document.body).on('updated_wc_div', function () {
    updateHeaderCartCount();
    updateCartSidebar();
  });

  // Update cart on page load if fragments are updated
  $(document.body).on('wc_fragments_refreshed', function () {
    updateHeaderCartCount();
    updateCartSidebar();
  });

  // Also listen for standard AJAX add to cart forms
  $('form.cart').on('submit', function (e) {
    var form = $(this);
    if (form.find('.single_add_to_cart_button').hasClass('ajax_add_to_cart')) {
      setTimeout(function () {
        updateHeaderCartCount();
        updateCartSidebar();
        openCartSidebar();
      }, 1000);
    }
  });

  // Listen for any AJAX add to cart buttons
  $('.ajax_add_to_cart').on('click', function () {
    setTimeout(function () {
      updateHeaderCartCount();
      updateCartSidebar();
      openCartSidebar();
    }, 1000);
  });
});
